import React from "react";
import { Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faToggleOff, faToggleOn } from "@fortawesome/free-solid-svg-icons";

type IntegracaoOptionsProps = {
    configData?: {
        flg_ecommerce: boolean;
        site: string;
        mail_host: string;
        usuario_magento: string;
        senha_magento: string;
        certificado: string;
        senha_certificado: string;
    };
    setConfigData?: any;
};

const IntegracaoOptions: React.FC<IntegracaoOptionsProps> = ({ configData, setConfigData }) => {
    const handleToggle = (key: keyof IntegracaoOptionsProps['configData']) => {
        if (setConfigData) {
            setConfigData({ ...configData, [key]: !configData![key] });
        }
    };

    return (
        <div className="card-body">
            <h5 className="mb-4">Opções de Integração</h5>
            <div className="border-bottom mb-3">
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <div className="d-flex align-items-center">
                        <span>Integração com E-commerce?</span>
                    </div>
                    <button
                        type="button"
                        className={`btn btn-sm ${configData?.flg_ecommerce ? "btn-outline-success" : "btn-outline-danger"} d-flex align-items-center`}
                        onClick={() => handleToggle("flg_ecommerce" as keyof IntegracaoOptionsProps["configData"])}
                    >
                        <FontAwesomeIcon icon={configData?.flg_ecommerce ? faToggleOn : faToggleOff} size="lg" />
                        <span className="ms-2">{configData?.flg_ecommerce ? "ON" : "OFF"}</span>
                    </button>
                </div>
                <p className="text-muted small mb-3">
                    Possibilita a integração com Magento, importando pedidos e exportando produtos.
                </p>
            </div>

            {/* Informações E-commerce */}
            {configData?.flg_ecommerce && (
                <div className="row gy-3">
                    <h6>Informações E-commerce</h6>
                    <Form.Group className="col-12 col-md-6" controlId="url-ecommerce">
                        <Form.Label>URL E-Commerce</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Digite a URL"
                            value={configData.site}
                            onChange={(e) =>
                                setConfigData({ ...configData, site: e.target.value })
                            }
                        />
                    </Form.Group>

                    <Form.Group className="col-12 col-md-6" controlId="link-webservice-ecommerce">
                        <Form.Label>Link WebService E-Commerce</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Digite o link"
                            value={configData.mail_host}
                            onChange={(e) =>
                                setConfigData({ ...configData, mail_host: e.target.value })
                            }
                        />
                    </Form.Group>

                    <Form.Group className="col-12 col-md-6" controlId="usuario-ecommerce">
                        <Form.Label>Usuário E-Commerce</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Digite o usuário"
                            value={configData.usuario_magento}
                            onChange={(e) =>
                                setConfigData({ ...configData, usuario_magento: e.target.value })
                            }
                        />
                    </Form.Group>

                    <Form.Group className="col-12 col-md-6" controlId="senha-ecommerce">
                        <Form.Label>Senha E-Commerce</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="Digite a senha"
                            value={configData.senha_magento}
                            onChange={(e) =>
                                setConfigData({ ...configData, senha_magento: e.target.value })
                            }
                        />
                    </Form.Group>
                </div>
            )}

            {/* Informações do Certificado Digital */}
            <div className="row border-top mt-3 gy-3">
                <div className="col-12 col-lg-6">
                    <h6>Informações do Certificado Digital</h6>
                    <p className="text-muted small">
                        Somente serão aceitos certificados do modelo A1.
                    </p>
                </div>
                <Form.Group controlId="selecionar-certificado" className="col-12 col-lg-6">
                    <Form.Label>Selecione Certificado Digital</Form.Label>
                    <Form.Control type="file" accept=".pfx" />
                </Form.Group>

                <Form.Group controlId="nome-arquivo-certificado" className="mt-3 col-12 col-lg-6">
                    <Form.Label>Nome do Arquivo</Form.Label>
                    <div className="text-truncate border p-2 rounded bg-light">
                        {configData?.certificado || "Nenhum certificado selecionado"}
                    </div>
                    </Form.Group>
                    <Form.Group controlId="senha-certificado" className='col-12 col-lg-6'>
                        <Form.Label>Senha do Certificado Digital</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="Digite a senha"
                            value={configData?.senha_certificado}
                            onChange={(e) =>
                                setConfigData({
                                    ...configData,
                                    senha_certificado: e.target.value,
                                })
                            }
                        />
                    </Form.Group>
            </div>
        </div>
    );
};

export default IntegracaoOptions;
